<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="模板编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'tempNo', validatorRules.tempNo]" placeholder="请输入模板编号"></a-input>
        </a-form-item>
        <a-form-item label="模板标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'tempTitle', validatorRules.tempTitle]" placeholder="请输入模板标题"></a-input>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['status', validatorRules.status]" :trigger-change="true" dictCode="app_status" placeholder="请选择状态"/>
        </a-form-item>
        <a-form-item label="应用标识" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'openHtml', validatorRules.openHtml]" placeholder="请输入应用标识"></a-input>
        </a-form-item>
        <a-form-item label="模板类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'tempType', validatorRules.tempType]" placeholder="请输入模板类型"></a-input>
        </a-form-item>
        <a-form-item label="模板内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['tempContent', validatorRules.tempContent]" rows="4" placeholder="请输入模板内容"/>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['remarks', validatorRules.remarks]" rows="4" placeholder="请输入备注"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JEditor from '@/components/jeecg/JEditor'

  export default {
    name: "BusInspectionGeneralSendMsgTemplateModal",
    components: { 
      JDictSelectTag,
      JEditor,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          tempNo: {rules: [
            {required: true, message: '请输入模板编号!'},
          ]},
          tempTitle: {rules: [
            {required: true, message: '请输入模板标题!'},
          ]},
          status: {rules: [
            {required: true, message: '请输入状态!'},
          ]},
          openHtml: {rules: [
            {required: true, message: '请输入应用标识!'},
          ]},
          tempType: {rules: [
            {required: true, message: '请输入模板类型!'},
          ]},
          tempContent: {rules: [
            {required: true, message: '请输入模板内容!'},
          ]},
          remarks: {rules: [
          ]},
        },
        url: {
          add: "/general/inspection/busInspectionGeneralSendMsgTemplate/add",
          edit: "general/inspection/busInspectionGeneralSendMsgTemplate/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'tempNo','tempTitle','status','openHtml','tempType','tempContent','remarks'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'tempNo','tempTitle','status','openHtml','tempType','tempContent','remarks'))
      },

      
    }
  }
</script>